export const stateName = 'catalogFilters';
export const FILTER_PRICE_FROM = 'priceFrom';
export const FILTER_PRICE_TO = 'priceTo';
export const CATALOG_FETCH_DEBOUNCE_AMOUNT = 500;
export const CATALOG_FILTERS_SEARCH_DEBOUNCE_AMOUNT = 300;
export const SCROLL_TO_TOP_DELAY = 1000;
export const SUPPORTED_FILTERS = {
  status: 'status',
  material: 'material',
  videoGameRating: 'video_game_rating',
  color: 'color',
  size: 'size',
  brand: 'brand'
};